export default "__VITE_ASSET__0c595ffb__"